// extracted by mini-css-extract-plugin
export var footer = "_lq-5";
export var fulfillmentInput = "_lq-0";
export var shipDateInput = "_lq-1";
export var shipmentModal = "_lq-2";
export var shipmentModalContent = "_lq-3";
export var tableContainer = "_lq-4";